var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "v-flex",
            { staticClass: "loading" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "" }
              })
            ],
            1
          )
        : _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "elevation-8",
                  staticStyle: { "border-radius": "10px" },
                  attrs: { width: "300" }
                },
                [
                  _c("v-tooltip", { attrs: { top: "" } }, [
                    _c(
                      "div",
                      { attrs: { slot: "activator" }, slot: "activator" },
                      [
                        _c("v-img", {
                          staticStyle: {
                            "border-top-left-radius": "10px",
                            "border-top-right-radius": "10px"
                          },
                          attrs: {
                            src: _vm.product.img,
                            "aspect-ratio": "3.15"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-card-title", { attrs: { "primary-title": "" } }, [
                          _c("div", { staticClass: "text-xs-left" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "headline mb-0 font-weight-bold title"
                              },
                              [_vm._v(_vm._s(_vm.product.title))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "py-2" }, [
                              _vm._v(" " + _vm._s(_vm.product.shortdesc) + " ")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "font-weight-bold" }, [
                              _vm._v(_vm._s(_vm.product.price))
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("En cliquant, l'internaute verra le produit "),
                      _c("br"),
                      _vm._v("dans une fenêtre flottante")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.product.addtocart
                    ? _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { top: "" } },
                            [
                              _c(
                                "template",
                                { slot: "activator" },
                                [
                                  _c(
                                    "v-btn",
                                    { attrs: { small: "", color: "info" } },
                                    [_vm._v("Ajouter au panier")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("En cliquant,"),
                                _c("br"),
                                _vm._v("l'internaute mettra le produit"),
                                _c("br"),
                                _vm._v("au panier")
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { top: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              slot: "activator",
                              flat: "",
                              icon: "",
                              small: "",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openDialogUpdate()
                              }
                            },
                            slot: "activator"
                          },
                          [_c("v-icon", [_vm._v("edit")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Modifier ce produit")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { top: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              slot: "activator",
                              flat: "",
                              icon: "",
                              small: "",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openDialogMove()
                              }
                            },
                            slot: "activator"
                          },
                          [_c("v-icon", [_vm._v("content_paste_go")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("changer de famille ce produit")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { top: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              slot: "activator",
                              flat: "",
                              icon: "",
                              small: "",
                              color: "primary"
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.openDialogDelete()
                              }
                            },
                            slot: "activator"
                          },
                          [_c("v-icon", [_vm._v("delete")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Supprimer ce produit")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600" },
          model: {
            value: _vm.showDialogUpdate,
            callback: function($$v) {
              _vm.showDialogUpdate = $$v
            },
            expression: "showDialogUpdate"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("edit"))) +
                    " " +
                    _vm._s(_vm.$tc("products", 1))
                )
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: { label: "Référence produit*" },
                    model: {
                      value: _vm.productDialog.ref,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "ref", $$v)
                      },
                      expression: "productDialog.ref"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      label: "Nom du produit*",
                      required: "",
                      "data-vv-name": "productInput",
                      error: _vm.wzErrors.has("productInput"),
                      errors: _vm.wzErrors.collect("productInput")
                    },
                    model: {
                      value: _vm.productDialog.title,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "title", $$v)
                      },
                      expression: "productDialog.title"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Description courte" },
                    model: {
                      value: _vm.productDialog.shortdesc,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "shortdesc", $$v)
                      },
                      expression: "productDialog.shortdesc"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-textarea", {
                    attrs: { label: "Mots clés (séparés par virgule)" },
                    model: {
                      value: _vm.productDialog.keywords,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "keywords", $$v)
                      },
                      expression: "productDialog.keywords"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Prix" },
                    model: {
                      value: _vm.productDialog.price,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "price", $$v)
                      },
                      expression: "productDialog.price"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Lien WEB" },
                    model: {
                      value: _vm.productDialog.link,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "link", $$v)
                      },
                      expression: "productDialog.link"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: { label: "Lien image/photo*" },
                    model: {
                      value: _vm.productDialog.img,
                      callback: function($$v) {
                        _vm.$set(_vm.productDialog, "img", $$v)
                      },
                      expression: "productDialog.img"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          label: _vm.productDialog.addtocart
                            ? "Boutton panier affiché"
                            : "Boutton panier masqué",
                          light: "",
                          color: "primary"
                        },
                        model: {
                          value: _vm.productDialog.addtocart,
                          callback: function($$v) {
                            _vm.$set(_vm.productDialog, "addtocart", $$v)
                          },
                          expression: "productDialog.addtocart"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("small", [_vm._v("*" + _vm._s(_vm.$t("required")))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogUpdate = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", disabled: _vm.wzErrors.any() },
                      on: { click: _vm.submitDialogUpdate }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.showDialogMove,
            callback: function($$v) {
              _vm.showDialogMove = $$v
            },
            expression: "showDialogMove"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("move"))) +
                    " " +
                    _vm._s(_vm.$tc("products", 1))
                )
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-select", {
                    attrs: {
                      label: "Choisissez la collection / famille",
                      items: _vm.$store.getters["_Rayons/GET_ALL_RAYON_TITLE"],
                      required: ""
                    },
                    model: {
                      value: _vm.rayonSelectId,
                      callback: function($$v) {
                        _vm.rayonSelectId = $$v
                      },
                      expression: "rayonSelectId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.showDialogMove = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.submitDialogMove }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.showDialogDelete,
            callback: function($$v) {
              _vm.showDialogDelete = $$v
            },
            expression: "showDialogDelete"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _vm._v(
                  _vm._s(_vm._f("cap")(_vm.$t("delete"))) +
                    " " +
                    _vm._s(_vm.$tc("products", 1))
                )
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("cap")(_vm.$t("delete"))) +
                    " " +
                    _vm._s(_vm.$tc("products", 1)) +
                    "?\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.showDialogDelete = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.submitDialogDelete.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c907d6b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c907d6b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzProduct.vue
// module id = null
// module chunks = 